import styled from 'styled-components';
import { getColor } from 'core/utils';
import { resetBtn } from 'styled-manila';

export const LoginWrapper = styled.div`
	margin-left: auto;
	margin-right: auto;
	margin-top: 50px;
	margin-bottom: 50px;
	min-width: 300px;
	max-width: 500px;
	width: 88vw;
	padding: 24px;
	background-color: ${getColor('white')};
	border-radius: 4px;
	position: relative;
	overflow-y: scroll;
	max-height: calc(100% - 53px);

	@media (min-width: 424px) {
		padding: 44px;
	}

	@media (min-width: 600px) {
		padding: 44px 88px;
	}
`;

export const DismissBtn = styled.button`
	${resetBtn};
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 0;
	right: 0;
	color: ${getColor('dustyGray')};
	padding: 17px;
`;
